<template>
  <modal
    name="balance-out"
    @before-open="beforeOpen"
    @before-close="beforeClose"
    :classes="[
      'v--modal',
      'modal',
      'balance-modal',
      'balance-out-modal',
      hasBugs && 'has-bugs',
    ]"
    :width="730"
    :height="'auto'"
    :scrollable="true"
    :adaptive="true"
  >
    <div class="modal-title">Вывод средств</div>
    <div class="modal-close" @click="close"></div>
    <div v-if="!initIsEmpty('init') && init.costs" class="modal-body">
      <div class="modal-subtitle">Выберите куда вывести деньги:</div>
      <ul class="balance-way-list">
        <li
          v-for="(way, index) in ways"
          @click="toggleWay(index)"
          class="balance-way-item"
          :key="index"
          :class="{ 'balance-way-item-selected': wayIndex == index }"
        >
          <div class="balance-way-text">{{ way }}</div>
        </li>
      </ul>
      <ul v-if="wayIndex !== 0" class="modal-list">
        <li class="modal-list-item">
          Выводить можно сумму не меньше
          {{ Math.floor(init.costs.withdrawal_min_amount) }}
          {{
            declineNouns(Math.floor(init.costs.withdrawal_min_amount), [
              "рубля",
              "рублей",
              "рублей",
            ])
          }}
        </li>
        <li class="modal-list-item">Вывод доступен не чаще 1 раза в месяц</li>
      </ul>
      <div class="balance-row">
        <div class="balance-col">
          <div class="balance-sum">
            <div class="modal-subtitle">Укажите сумму для вывода</div>
            <div class="balance-sum-wrapper">
              <input
                v-model="amount"
                v-validate.persist="{
                  required: true,
                  min_value:
                    wayIndex === 0 ? 1 : init.costs.withdrawal_min_amount,
                  max_value: user.account_balance,
                }"
                name="amount"
                type="text"
                class="input"
                :class="{ 'field-error': errors.has('amount') }"
              />
            </div>
            <div class="v-error">{{ errors.first("amount") }}</div>
          </div>
          <div class="balance-balance">
            на вашем счете:
            <span
              @click="amount = user.account_balance"
              class="balance-balance-value"
              >{{ user.account_balance }} руб.</span
            >
          </div>
        </div>
        <div class="balance-col">
          <div v-if="wayIndex == 0" class="balance-output">
            <div class="modal-subtitle">Придет на баланс</div>
            <div class="balance-output-wrapper">
              <input
                :value="Math.floor(amount / init.costs.exchange_rate)"
                type="text"
                class="input"
                readonly
              />
            </div>
          </div>
          <div v-if="wayIndex == 1" class="balance-phone">
            <div class="modal-subtitle">Введите номер карты</div>
            <input
              v-model="card"
              v-validate.persist="'required|credit_card'"
              key="card"
              name="card"
              type="text"
              class="input"
              :class="{ 'field-error': errors.has('card') }"
            />
            <div class="v-error">{{ errors.first("card") }}</div>
          </div>
          <div v-if="wayIndex == 2 || wayIndex == 3" class="balance-phone">
            <div class="modal-subtitle">Введите ваш номер телефона</div>
            <input
              v-model="phone"
              v-validate.persist="{
                required: true,
                regex: /^\+[0-9]{11,}$/,
                min: 11,
              }"
              name="phone"
              key="phone"
              type="text"
              class="input"
              :class="{ 'field-error': errors.has('phone') }"
            />
            <div class="v-error">{{ errors.first("phone") }}</div>
          </div>
        </div>
      </div>

      <div class="buttons-row">
        <button @click="close" type="button" class="button-secondary">
          Отмена
        </button>
        <button @click="send" v-if="!loader" class="button">Продолжить</button>
        <button
          v-if="loader"
          type="button"
          class="button button-loader"
        ></button>
      </div>
    </div>
    <div v-else><button class="button-loader"></button></div>
  </modal>
</template>

<script>
import { mapGetters } from "vuex";
import { localizeValidation } from "@/mixins/localizeValidation";
import { checkScroll } from "@/mixins/checkScroll";
import { declineNouns } from "@/mixins/declineNouns";

export default {
  name: "BalanceOut",
  mixins: [localizeValidation, checkScroll, declineNouns],
  data() {
    return {
      phone: "",
      card: "",
      amount: "",
      output: "",
      hasBugs: false,
      loader: false,
      wayIndex: 0,
      ways: ["Баланс сайта", "Банковские карты", "Мобильный платеж", "Qiwi"],
    };
  },
  computed: {
    ...mapGetters({
      user: "user/fetchUser",
      balanceErrors: "balance/errors",
      init: "init/fetchInit",
      initIsEmpty: "init/isEmpty",
    }),
    // rate() {
    //     return this.init.costs.exchange_rate;
    // }
  },
  watch: {
    $route(to, from) {
      if (to != from) {
        this.$modal.hide("balance-out");
      }
    },
  },
  methods: {
    beforeOpen() {
      this.checkScroll();
      this.localizeValidation();
      this.phone = this.user.phone;
      let amount = this.init.costs.withdrawal_min_amount;
      if (amount.split(".")[1] === "00") {
        amount = amount.split(".")[0];
      }
      this.$validator.localize("ru", {
        messages: {
          min_value: () =>
            "укажите сумму не ниже " +
            amount +
            " " +
            this.declineNouns(amount, ["рубля", "рублей", "рублей"]),
        },
      });
    },
    beforeClose() {
      this.checkRemoveScroll();
    },
    send() {
      if (this.loader) {
        return;
      }
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          this.loader = true;
          let action,
            data = { amount: this.amount };
          if (this.wayIndex == 0) {
            action = "balance/exchange";
          } else {
            action = "balance/withdraw";
            data.type = this.wayIndex;
            data.purse =
              this.wayIndex == 1 ? this.card.replace(/[- ]+/g, "") : this.phone;
          }
          this.$store
            .dispatch(action, data)
            .then(() => {
              this.loader = false;
              this.resetForm();
              this.$modal.hide("balance-out");
              this.$modal.show("dialog", {
                text: "Средства успешно выведены!",
                buttons: [
                  {
                    title: "Ок",
                  },
                ],
              });
            })
            .catch(() => {
              this.loader = false;
              // TODO: при ошибке возвращать средства на баланс
            });
        }
      });
    },
    resetForm() {
      this.amount = "";
      this.phone = "";
      this.card = "";
      this.errors.clear();
      this.$validator.reset();
    },
    toggleWay(index) {
      this.resetForm();
      this.wayIndex = index;
    },
    close() {
      this.resetForm();
      this.$modal.hide("balance-out");
    },
    calcOutput() {
      this.output = this.amount / this.init.costs.exchange_rate;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_validation";
@import "~@/assets/styles/layout/_balance";
.error-modal {
  transition: box-shadow 1s;
  &.has-bugs {
    box-shadow: 0 24px 80px -2px rgba(255, 0, 0, 0.4) !important;
  }
}
</style>
